<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" class="pl-0">
          <h4 class="font-weight-regular primary--text">Platos más vendidos</h4>
        </v-col>
      </v-row>

      <v-row v-if="!loading">
        <v-col cols="12" class="pa-0">
          <template>
            <v-data-table
              :headers="headers"
              :items="bests"
              item-key="name"
              hide-default-footer
              class="elevation-1">

              <!-- Columna cantidad -->
              <template v-slot:item.quantity="{ item }" class="align-center">
                <div class="text-right">
                  {{ item.quantity | toFixNumber(0) }}
                </div>
              </template>

              <!-- Columna subtotal -->
              <template v-slot:item.subtotal="{ item }" class="align-center">
                <div class="text-right">
                  {{ item.subtotal | toFixNumber(2) | numberWithComma | prefix('$') }}
                </div>
              </template>

              <!-- Columna total -->
              <template v-slot:item.total="{ item }" class="align-center">
                <div class="text-right">
                  {{ item.total | toFixNumber(2) | numberWithComma | prefix('$') }}
                </div>
              </template>

            </v-data-table>
          </template>
        </v-col>
      </v-row>

      <loader :loading="loading"></loader>

    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loader from '@/components/Loader'

export default {
  name: 'best-sellers-clients',
  props: {
    restaurant: {
      type: Object
    },
    dates: {
      type: Array,
      required: true
    },
    period: {
      type: String,
      required: true
    }
  },
  components: { Loader },
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Platillo', align: 'left', value: 'recipeName', sortable: false },
        { text: 'Cantidad', align: 'left', value: 'quantity', sortable: false },
        { text: 'Subtotal', align: 'left', value: 'subtotal', sortable: false },
        { text: 'Total', align: 'left', value: 'total', sortable: false }
        // { text: '% de ventas', align: 'left', value: 'percentage', sortable: false }
      ],
      bests: []
    }
  },
  computed: {
    ...mapGetters(['total_sales'])
  },
  methods: {
    async getItems () {
      let [ fromDate ] = this.dates
      this.loading = true
      try {
        const salesByDish = await this.$api.get(`/v1/restaurants/${this.restaurant._id}/reports/sales-by-dish`, {
          date: fromDate,
          type: this.period
        })
        this.bests = salesByDish.filter(sale => sale.total > 0)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loading = false
    }
  },
  async mounted () {
    await this.getItems()
  },
  watch: {
    dates: function (value) {
      this.getItems()
    }
  }
}
</script>
